import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import React from "react";
import { useRouter, useLocalSearchParams } from "expo-router";
import { useSelector } from "react-redux";
import FooterComponent from "../component/footer";
import { useLanguage } from "./LanguageProvider";

export default function successprocess() {
  const { t } = useLanguage();
  const router = useRouter();
  const {
    item2: itemParam2,
    scale: itemParamscale,
    data: dataparam,
  } = useLocalSearchParams();

  const item2 =
    typeof itemParam2 === "string" ? JSON.parse(itemParam2) : itemParam2;

  const response =
    useSelector((state: any) => state?.scale?.postweight) || null;

  const enterlocation =
    useSelector((state: any) => state?.scale?.enterlocation) || null;

  // console.log("item2", JSON.stringify(item2, null, 2));
  // console.log("response", JSON.stringify(response, null, 2));
  // console.log("enterlocation", JSON.stringify(enterlocation, null, 2));

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        {/* ScrollView ครอบเนื้อหาทั้งหมด */}
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[95%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
        >
          <View className="w-full items-center justify-center border-b border-gray-300 pb-5 mb-1">
            <Image
              source={require("../../assets/success.png")}
              className="w-24 h-24 rounded-full border-8 p-1 border-[#a3e4d7]"
            />
            <Text className="text-xl font-kanit text-gray-500 py-3">
              {/* เลือกสถานที่จัดเก็บสำเร็จ! */}
              {t("success_select_storage_location")}
            </Text>
            <Text className="text-4xl font-kanit">
              {enterlocation?.order_name
                ? enterlocation?.order_name
                : t("no_data")}
            </Text>
          </View>

          <ScrollView className="w-full flex-1 pt-2">
            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* ชื่อ */}
                {t("name")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {enterlocation?.productname
                  ? enterlocation?.productname
                  : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* สถานที่ที่รับของ */}
                {t("location_received")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {enterlocation?.oldlocation
                  ? enterlocation?.oldlocation
                  : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* วันและเวลาที่ดำเนินการ */}
                {t("date_time_process")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {enterlocation?.time ? enterlocation?.time : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* จุดชั่งน้ำหนัก */}
                {t("weight_point")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {enterlocation?.weightlocation
                  ? enterlocation?.weightlocation
                  : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* จำนวน */}
                {t("quantity")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {response?.meter ? response?.meter : t("no_data")}{" "}
                {response?.unit ? response?.unit : ""}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* ผู้ดำเนินการ */}
                {t("operator")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {enterlocation?.employee_name
                  ? enterlocation?.employee_name
                  : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between border-b border-gray-300 py-2 mb-2"></View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* สถานที่จัดเก็บ */}
                {t("location")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {enterlocation?.locationname
                  ? enterlocation?.locationname
                  : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* หมายเลขภาชนะ */}
                {t("container_number")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {enterlocation?.container_id
                  ? enterlocation?.container_id
                  : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* น้ำหนักที่ชั่งได้ */}
                {t("weight_measured")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {response?.weight ? response?.weight + " KG." : t("no_data")}
              </Text>
            </View>
          </ScrollView>

          <View className="flex flex-row items-center justify-between py-2 border-t pt-5 border-gray-300">
            <View className="w-full flex-row items-center justify-center">
              <TouchableOpacity
                // onPress={() => router.push("/screens/home")}
                onPress={() => {
                  router.push({
                    pathname: "/screens/order_scales",
                    params: {
                      machine_code: item2.machine_code,
                      item: JSON.stringify(item2)
                    },
                  });
                } }
                className="w-full bg-[#58d68d] py-3 rounded-xl items-center shadow-sm"
              >
                <Text className="text-white text-lg font-kanit">
                  {/* เสร็จสิ้น */}
                  {t("complete")}
                  </Text>
              </TouchableOpacity>
            </View>
          </View>
        </ScrollView>
      </View>
    </>
  );
}
